import {useEffect, useRef} from 'react'
import {useUrlUpdater} from 'components/data/WithUrlUpdater'
import {FilterUrlParams} from 'modules/search/types'

import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'

import type {RouterContextProps} from '@vio/core/src/_web/router/context/RouterContext'

const getFilterParams = (
  getQueryParams: RouterContextProps['getQueryParams']
) => {
  return getQueryParams() as {
    roomFilters?: string
    freeCancellation?: BooleanUrlParam
    amenities?: string
  }
}

export const useSyncFilters = () => {
  const {getQueryParams, pathname} = useRouterProvider()
  const {updateLocation} = useUrlUpdater()
  const isFirstRender = useRef(true)

  const {roomFilters: activeRoomsFilters} = getFilterParams(getQueryParams)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    // Applies room filters to url with SRP filters to update search result for top offers
    const newSearchFilters: FilterUrlParams = {
      amenities: activeRoomsFilters?.includes('breakfastIncluded')
        ? ['breakfast']
        : undefined,
      freeCancellation: activeRoomsFilters?.includes('freeCancellation')
        ? '1'
        : undefined,
      payLater: activeRoomsFilters?.includes('payLater') ? '1' : undefined,
      dealFreeze: activeRoomsFilters?.includes('dealFreeze') ? '1' : undefined // Added as a part of c747927f-deal-freeze-srp
    }

    updateLocation(newSearchFilters, {
      basePath: pathname,
      method: 'replace',
      mergeWithCurrentParams: true,
      shallow: true
    })
  }, [updateLocation, pathname, activeRoomsFilters])
}
